import jwtDecode from 'jwt-decode';

const isTokenExpired = (token: string) => {
    // Get the current UTC time and compare to the token expiry -
    // https://github.com/auth0/jwt-decode/issues/53#issuecomment-352365875
    const currentTimestamp = Math.floor(Date.now().valueOf() / 1000);
    const expireTime = (jwtDecode(token) as { [prop: string]: any }).exp;
    return expireTime < currentTimestamp;
};

export default isTokenExpired;
